<script lang="ts">
    import {TEMPLATE, ANIMATION_DURATION} from 'general/constants';

    import s from './style.module.css';

    export let template = 'circle';
    export let labelId = 'dialog';
    export let color: 'light' | 'colored' | 'dark' = 'colored';
    export let isSmallerScreen = false;

    $: circle = template === TEMPLATE.CIRCLE;
    $: square = template === TEMPLATE.SQUARE;
    $: squareProduct = template === TEMPLATE.SQUARE_PRODUCT;
    $: squareMobile = template === TEMPLATE.SQUARE_MOBILE;
    $: squareExit = template === TEMPLATE.SQUARE_EXIT;
    $: squareExitCart = template === TEMPLATE.SQUARE_EXIT_CART;
    $: imageMobile = template === TEMPLATE.IMAGE_MOBILE;
    $: expSquare = template === TEMPLATE.EXP_SQUARE;
    $: expSquareMobile = template === TEMPLATE.EXP_SQUARE_MOBILE;
    $: squareWithLogosMobile = template === TEMPLATE.SQUARE_WITH_LOGOS_MOBILE;
    $: squareAdvantagesMobile = template === TEMPLATE.SQUARE_MOBILE_ADVANTAGES;
    $: squareExitRecommendations = template === TEMPLATE.SQUARE_EXIT_RECOMMENDATIONS;
    $: squareGenderMobile = template === TEMPLATE.SQUARE_GENDER_MOBILE;
    $: squareDesktopCommon = template === TEMPLATE.SQUARE_DESKTOP_COMMON;
    $: squareExitRedesign = template === TEMPLATE.SQUARE_EXIT_REDESIGN;
</script>

<div
    class={s[color] || ''}
    class:s.circle={circle}
    class:s.square={square}
    class:s.squareProduct={squareProduct}
    class:s.squareMobile={squareMobile}
    class:s.squareExitCart={squareExitCart}
    class:s.imageMobile={imageMobile}
    class:s.squareExit={squareExit}
    class:s.expSquare={expSquare}
    class:s.expSquareMobile={expSquareMobile}
    class:s.squareWithLogosMobile={squareWithLogosMobile}
    class:s.squareAdvantagesMobile={squareAdvantagesMobile}
    class:s.squareExitRecommendations={squareExitRecommendations}
    class:s.squareGenderMobile={squareGenderMobile}
    class:s.squareDesktopCommon={squareDesktopCommon}
    class:s.squareExitRedesign={squareExitRedesign}
    class:s.smallScreen={isSmallerScreen}
    role="dialog"
    aria-labelledby={labelId}
    style="transition: {ANIMATION_DURATION.ANIMATION_THEME}ms all"
>
    <div class={s.wrapper}>
        <div class={s.box}>
            <slot />
        </div>
    </div>
</div>
